import { memo, useEffect, useRef, useState } from 'react';
import { Tooltip } from '@fuxi/eevee-ui';
import classNames from 'classnames/bind';
import { isNil } from 'lodash-es';
import { groupReviewByFrameIndex, groupReviewByTakeIndex } from './util';
import { PlayerBarActionMode, defaultStyle } from './PlayerBar';

import styles from './index.module.css';

const cx = classNames.bind(styles);

const calculateMarkLeft = ({ tickWidth, markMiddleWidth, frameIndex, mode }) => {
  let markLeft = (frameIndex - 1) * tickWidth + tickWidth / 2 - markMiddleWidth / 2; // 向右偏移半格,减去中线半宽，居中对齐
  if (mode === 'review') {
    markLeft -= tickWidth / 2;
  }

  return markLeft;
};

const markHoverStyle = ({ tickWidth, frameIndex, mode }) => {
  const left = calculateMarkLeft({ frameIndex, mode, tickWidth, markMiddleWidth: defaultStyle.markMiddleWidth });
  const width = tickWidth < defaultStyle.markMiddleWidth ? defaultStyle.markMiddleWidth : tickWidth;

  return {
    width: `${width}px`,
    left: `${left}px`,
    opacity: 1,
  };
};

const ReviewMarkTip = ({ reviewList, curTakeIndex, tickWidth }) => {
  const markRef = useRef<any>(null);
  const [reviews, setReviews] = useState<{ reviewKeys: string[]; reviewMap: Record<string, any[]> }>({
    reviewKeys: [],
    reviewMap: {},
  });
  const formatReviews = () => {
    let reviewKeys: string[] = [],
      reviewMap: any = {};
    if (reviewList) {
      // 先按照reviewList里的takeIndex分组
      const groupedReviewList = groupReviewByTakeIndex(reviewList);
      // 再按照每个takeIndex里的frameIndex分组

      if (!isNil(curTakeIndex)) {
        const curTakeReviewList = groupedReviewList[curTakeIndex];
        if (curTakeReviewList) {
          reviewMap = groupReviewByFrameIndex(curTakeReviewList);
          reviewKeys = Object.keys(reviewMap);
        }
      }
    }
    setReviews({
      reviewKeys,
      reviewMap,
    });
  };

  useEffect(() => {
    formatReviews();
  }, [reviewList, curTakeIndex, tickWidth]);

  return (
    <>
      {reviews.reviewKeys.map((reviewKey: string) => {
        return (
          <Tooltip
            placement="top"
            trigger={['hover']}
            key={reviewKey as string}
            title={`${reviews.reviewMap[reviewKey]?.length}条反馈`}>
            <div
              className={cx('mark', 'mark-hover', 'mark-hover--review')}
              ref={markRef}
              style={markHoverStyle({
                frameIndex: Math.round(parseFloat(reviewKey)),
                mode: PlayerBarActionMode.Review,
                tickWidth: tickWidth,
              })}>
              <div className={cx('mark-middle')} />
            </div>
          </Tooltip>
        );
      })}
    </>
  );
};
export default memo(ReviewMarkTip);
